import styled from "@emotion/styled";
import { FC, PropsWithChildren } from "react";
import { HyperLink } from "src/atoms/HyperLink";
import { Trans } from "@lingui/macro";

interface Props extends PropsWithChildren {
  link?: string;
  onClick?: () => void;
  overlayBgColor?: string;
}

const StyledBlurredItem = styled.div<{ bgColor?: string }>`
  position: relative;
  height: 100%;
  width: 100%;
  opacity: 0.3;
  filter: blur(4px);
  background: ${({ bgColor }) => (bgColor ? bgColor : "transparent")};
`;

const StyledLinkContainer = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  align-items: stretch;
  height: 100%;
  width: 100%;
`;

const CarouselOverlay: FC<Props> = ({
  children,
  link,
  onClick,
  overlayBgColor,
}) => {
  return (
    <>
      <StyledBlurredItem bgColor={overlayBgColor}>{children}</StyledBlurredItem>
      <StyledLinkContainer>
        {link ? (
          <HyperLink href={link} hasUnderline fullWidth onClick={onClick}>
            <Trans>View all</Trans>
          </HyperLink>
        ) : (
          <HyperLink hasUnderline fullWidth onClick={onClick}>
            <Trans>View all</Trans>
          </HyperLink>
        )}
      </StyledLinkContainer>
    </>
  );
};

export default CarouselOverlay;
